import IFrameIntervalSelection from './IFrameIntervalSelection'

export default IFrameIntervalSelection
